import MedicineConfig from "@/views/configs/medicine/index.vue";
import ApplicationRouteConfig from "@/views/configs/medicine/application_route.vue";
import PresentationConfig from "@/views/configs/medicine/presentation.vue";
import MedicinesConfig from "@/views/configs/medicine/medicines.vue";

export default [
  {
    path: "medicamento",
    component: MedicineConfig,
    children: [
      {
        path: "vias-aplicacao",
        name: "Vias de aplicação",
        component: ApplicationRouteConfig,
      },
      {
        path: "apresentacao",
        name: "Apresentação",
        component: PresentationConfig,
      },
      {
        path: "",
        name: "Medicamentos",
        component: MedicinesConfig,
      },
    ],
  },
];
